/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
import type {ProjectOut} from './ProjectOut';
import {ProjectOutFromJSON, ProjectOutFromJSONTyped, ProjectOutToJSON} from './ProjectOut';

/**
 *
 * @export
 * @interface PageTypeVarCustomizedProjectOut
 */
export interface PageTypeVarCustomizedProjectOut {
  /**
   *
   * @type {Array<ProjectOut>}
   * @memberof PageTypeVarCustomizedProjectOut
   */
  items: Array<ProjectOut>;
  /**
   *
   * @type {number}
   * @memberof PageTypeVarCustomizedProjectOut
   */
  total: number | null;
  /**
   *
   * @type {number}
   * @memberof PageTypeVarCustomizedProjectOut
   */
  page: number | null;
  /**
   *
   * @type {number}
   * @memberof PageTypeVarCustomizedProjectOut
   */
  size: number | null;
  /**
   *
   * @type {number}
   * @memberof PageTypeVarCustomizedProjectOut
   */
  pages?: number | null;
}

/**
 * Check if a given object implements the PageTypeVarCustomizedProjectOut interface.
 */
export function instanceOfPageTypeVarCustomizedProjectOut(
  value: object
): value is PageTypeVarCustomizedProjectOut {
  if (!('items' in value) || value['items'] === undefined) return false;
  if (!('total' in value) || value['total'] === undefined) return false;
  if (!('page' in value) || value['page'] === undefined) return false;
  if (!('size' in value) || value['size'] === undefined) return false;
  return true;
}

export function PageTypeVarCustomizedProjectOutFromJSON(
  json: any
): PageTypeVarCustomizedProjectOut {
  return PageTypeVarCustomizedProjectOutFromJSONTyped(json, false);
}

export function PageTypeVarCustomizedProjectOutFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PageTypeVarCustomizedProjectOut {
  if (json == null) {
    return json;
  }
  return {
    items: (json['items'] as Array<any>).map(ProjectOutFromJSON),
    total: json['total'],
    page: json['page'],
    size: json['size'],
    pages: json['pages'] == null ? undefined : json['pages']
  };
}

export function PageTypeVarCustomizedProjectOutToJSON(
  value?: PageTypeVarCustomizedProjectOut | null
): any {
  if (value == null) {
    return value;
  }
  return {
    items: (value['items'] as Array<any>).map(ProjectOutToJSON),
    total: value['total'],
    page: value['page'],
    size: value['size'],
    pages: value['pages']
  };
}
